import React from 'react';

import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import { aiProactiveMessages } from '@atlaskit/editor-common/ai-messages';
import Heading from '@atlaskit/heading';
import Image from '@atlaskit/image';
import { Stack, Text } from '@atlaskit/primitives/compiled';

import NoSuggestionsImageDark from '../assets/no-suggestions/dark.svg';
import NoSuggestionsImageLight from '../assets/no-suggestions/light.svg';

export const NoSuggestionsState = ({
	handleAskAI,
	isEditorDisabled,
}: {
	handleAskAI: () => void;
	isEditorDisabled?: boolean;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();
	// eslint-disable-next-line @atlassian/a11y/alt-text -- See https://go/a11y-alt-text for more details
	<Image src={NoSuggestionsImageLight} srcDark={NoSuggestionsImageDark} />;

	return (
		<Stack space="space.200" alignInline="center" grow="fill">
			{/* eslint-disable-next-line @atlassian/a11y/alt-text -- See https://go/a11y-alt-text for more details */}
			<Image src={NoSuggestionsImageLight} srcDark={NoSuggestionsImageDark} />
			<Stack space="space.200" alignInline="center">
				<Heading color="color.text" size="small">
					{formatMessage(aiProactiveMessages.noSuggestionsStateTitle)}
				</Heading>
				<Text align="center" color="color.text" size="medium">
					{formatMessage(aiProactiveMessages.noSuggestionsStateDescription, {
						i: (parts: React.ReactNode[]) => <i>{parts}</i>,
					})}
				</Text>
				<Button appearance="default" onClick={handleAskAI} isDisabled={isEditorDisabled}>
					{formatMessage(aiProactiveMessages.askAIButtonLabel)}
				</Button>
			</Stack>
		</Stack>
	);
};
